import { MenuItem, Typography } from '@material-ui/core';
import React, { FC } from 'react';

import { Caret } from 'src/Icons';
import { Action } from 'src/StatusLabel';
import { StatusLabelClassNames } from 'src/types';

export interface StatusLabelMenuActionsProps {
  actions: Action[];
  handleClose: () => void;
}

/**
 * `MenuItem`, not a bare `li`: it carries `role="menuitem"`, the `tabindex`
 * `MenuList` walks for arrow navigation, and `ButtonBase`'s Enter and Space
 * handling. Its own gutters and ripple are dropped so the row keeps the
 * geometry `FountainStatusLabel-menu-actions` gives it.
 */
export const StatusLabelMenuActions: FC<StatusLabelMenuActionsProps> = ({ actions, handleClose }) => {
  const handleClick = (callback: () => void) => (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    handleClose();
    callback();
  };
  return (
    <>
      {actions.map(action => (
        <MenuItem
          key={action.label}
          className={StatusLabelClassNames.MENU_ACTIONS}
          disableGutters
          disableRipple
          onClick={handleClick(action.onClick)}
        >
          <Typography component="p" noWrap variant="overline">
            {action.label}
          </Typography>
          <Caret className={StatusLabelClassNames.ACTION_ICON} />
        </MenuItem>
      ))}
    </>
  );
};
